module.exports = __webpack_public_path__ + "static/media/alimentacao.44dbaa78.svg";